import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { generateBurokAppPathNativeDeeplink } from '../src/utils/burokLinkDeeplink';
import OpenInAppInterstitial from './OpenInAppInterstitial';

/**
 * app.burok.app/* — hôte canonique des deeplinks app (hors paiement).
 * Ex. /messages, /friend/{id}, /app/3, /kiosk?...
 * → tente burokapp://{path}?{query}
 */
export default function AppDeepLinkOpenPage() {
  const location = useLocation();

  const openUrl = useMemo(
    () => generateBurokAppPathNativeDeeplink(location.pathname, location.search),
    [location.pathname, location.search]
  );

  const isRoot = location.pathname === '/' || location.pathname === '';

  if (isRoot) {
    return (
      <OpenInAppInterstitial
        openUrl="burokapp://"
        title="Ouvrir Burok"
        subtitle="Ce domaine ouvre l’application Burok (messages, amis, mini-apps…)."
      />
    );
  }

  return (
    <OpenInAppInterstitial
      openUrl={openUrl}
      title="Ouverture de Burok…"
      subtitle="Si rien ne se passe, l’application n’est peut‑être pas installée."
    />
  );
}
